import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { PERIOD_BASED_REPORT_QUERY } from '../../../graphql.js'
import { Link, useNavigate } from 'react-router-dom'
import { getData, getInputParams } from '../CustomUtils.js'
import FormHeading from '../FormHeading.js'

const PERIOD_BASED_REPORT = gql(PERIOD_BASED_REPORT_QUERY)

export default function PeriodBasedReport({ location }) {
  console.log('PeriodBasedReport rendered:')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    getData(location, PERIOD_BASED_REPORT, 'periodBasedReport', setResults, setGraphQLErrors)
  }, [location])

  function makeTableBody(headingText, bodyArray, reportType, noTotal, inStatus, isReclosed) {
    const body = []
    let total = 0
    let row = []
    const inputs = getInputParams(location)
    for (let i = 0; i < bodyArray.length; i++) {
      if (noTotal) {
        inputs.reportType = reportType
        inputs.procedureName = 'claims'
        if (isReclosed && i > 0) {
          inputs.reportType = 'Re-closed'
        }
        if (inStatus) {
          inputs.procedureName = 'claims_status_changed'
          inputs.reportType = bodyArray[i].name
        }
        let href = `/custom/period_based_details?inputs=${JSON.stringify(inputs)}`
        row.push(<td width='50%' key={bodyArray[i].name}><Link to={href} onClick={() => navigate(href)}>{bodyArray[i].name}</Link></td>)
      } else {
        inputs.reportType = reportType
        inputs.injuryName = bodyArray[i].name
        inputs.procedureName = 'claims_by_injury'
        let href = `/custom/period_based_details?inputs=${JSON.stringify(inputs)}`
        row.push(<td width='50%' key={bodyArray[i].name}>&emsp; <Link to={href} onClick={() => navigate(href)}>{bodyArray[i].name}</Link></td>)
      }

      row.push(<td key={i} align='right'>{new Intl.NumberFormat().format(bodyArray[i].count)}</td>)

      if (bodyArray[i].avgCost !== undefined) {
        body.push(<tr key={'avgCost' + i}>{row}</tr>)
        row = []
        row.push(<td width='50%' key={'avg' + i} align='right'>Average Cost</td>)
        row.push(<td key={'avg$' + i} align='right'>${new Intl.NumberFormat().format(bodyArray[i].avgCost)}</td>)
      }

      total += bodyArray[i].count
      body.push(<tr key={i}>{row}</tr>)
      row = []
    }
    if (!noTotal) {
      row.push(<td width='50%' key='total'><b>Total Number of Claims</b></td>)
      row.push(<td width='50%' key='totalNumber' align='right'>{new Intl.NumberFormat().format(total)}</td>)
      body.push(<tr key='totalColumn'>{row}</tr>)
    }

    return (
      <div>
        <Table bordered style={{width: '90%', marginLeft: 'auto', marginRight: 'auto'}}>
          <FormHeading headingText={headingText} />
          <tbody>
            {body}
          </tbody>
        </Table>
      </div>
    )
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const inputs = getInputParams(location)
    let totalPayClaims = 0
    const zeroPayRows = []
    let zeroPayTotal = 0
    let positivePayTotal = 0
    if (results.claimsClosed.bySettlementZeroPay.length > 0) {
      for (let i = 0; i < results.claimsClosed.bySettlementZeroPay.length; i++) {
        let row = []
        inputs.reportType = 'Zero Pay'
        inputs.injuryName = results.claimsClosed.bySettlementZeroPay[i].name
        inputs.procedureName = 'claims_closed_by_settlement'
        let href = `/custom/period_based_details?inputs=${JSON.stringify(inputs)}`
        row.push(<td width='50%' key={results.claimsClosed.bySettlementZeroPay[i].name}>&emsp;<Link to={href} onClick={() => navigate(href)}>{results.claimsClosed.bySettlementZeroPay[i].name}</Link></td>)
        row.push(<td key={i} align='right'>{new Intl.NumberFormat().format(results.claimsClosed.bySettlementZeroPay[i].count)}</td>)
        zeroPayRows.push(<tr key={i}>{row}</tr>)
        zeroPayTotal += results.claimsClosed.bySettlementZeroPay[i].count
        totalPayClaims += results.claimsClosed.bySettlementZeroPay[i].count
      }
    }
    zeroPayRows.push(<tr key={-1}><td>Total Number of Zero Pay Claims</td><td align='right'>{new Intl.NumberFormat().format(zeroPayTotal)}</td></tr>)
    const positivePayRows = []
    
    if (results.claimsClosed.bySettlementPositivePay.length > 0) {
      for (let i = 0; i < results.claimsClosed.bySettlementPositivePay.length; i++) {
        let row = []
        inputs.reportType = 'Positive Pay'
        inputs.injuryName = results.claimsClosed.bySettlementPositivePay[i].name
        inputs.procedureName = 'claims_closed_by_settlement'
        let href = `/custom/period_based_details?inputs=${JSON.stringify(inputs)}`
        row.push(<td width='50%' key={results.claimsClosed.bySettlementPositivePay[i].name}>&emsp;<Link to={href} onClick={() => navigate(href)}>{results.claimsClosed.bySettlementPositivePay[i].name}</Link></td>)
        row.push(<td key={i} align='right'>{new Intl.NumberFormat().format(results.claimsClosed.bySettlementPositivePay[i].count)}</td>)
        positivePayRows.push(<tr key={i}>{row}</tr>)
        positivePayTotal += results.claimsClosed.bySettlementPositivePay[i].count
        totalPayClaims += results.claimsClosed.bySettlementPositivePay[i].count
      }
    }
    positivePayRows.push(<tr key={-1}><td>Total Number of Positive Pay Claims</td><td align='right'>{new Intl.NumberFormat().format(positivePayTotal)}</td></tr>)

    console.log('readfasfea', results)
    const claimsEnteredArray = []
    claimsEnteredArray.push(results.claimsEntered.total)
    const ClaimsEnteredTable = makeTableBody('Claims Entered', claimsEnteredArray, 'Entered', true)
    const OpenDiagnosisTable = makeTableBody('Claims Entered By Current Diagnosis', results.claimsEntered.byDiagnosis, 'Entered')
    const ClaimsClosedTable = makeTableBody('Claims Closed', results.claimsClosed.total, 'Closed', true, false, true)
    const ClosedDiagnosisTable = makeTableBody('Claims Closed By Current Diagnosis', results.claimsClosed.byDiagnosis, 'Closed')
    const ClaimsChangeStatusTable = makeTableBody('Claims With Change in Status', results.claimsWithChangeInStatus, '', true, true)
    const ClaimsClosedBySettlementTable = 
    <div>
      <Table bordered style={{width: '90%', marginLeft: 'auto', marginRight: 'auto'}}>
        <thead>
          <tr>
            <th colSpan={2} style={{textAlign: 'left'}}>Claims Closed By Settlement</th>
          </tr>
        </thead>
        <tbody>
          <tr><td colSpan={2}><b>Zero Pay (claims which closed with a settlement amount equal to zero or with no amount entered)</b></td></tr>
          {zeroPayRows}
          <tr><td colSpan={2}><b>Positive Pay (claims which closed with a dollar amount greater than zero)</b></td></tr>
          {positivePayRows}
          <tr><td width='50%'><b>Total Number of Claims</b></td><td align='right'>{new Intl.NumberFormat().format(totalPayClaims)}</td></tr>
        </tbody>
      </Table>
    </div>

    let dateFrom = 'Inception'
    let dateTo = 'Present'
    if (inputs.dateFrom) {
      dateFrom = inputs.dateFrom.split('-')
      dateFrom = dateFrom[1] + '-' + dateFrom[2] + '-' + dateFrom[0]
    }
    if (inputs.dateTo) {
      dateTo = inputs.dateTo.split('-')
      dateTo = dateTo[1] + '-' + dateTo[2] + '-' + dateTo[0]
    }

    const dateInputs = `(From ${dateFrom} to ${dateTo})`
    const checkboxInputs = inputs.includeNullDates === 'Y' ? 'Includes records where Date Assigned is not specified' : ''

    return (
      <div className="custom-scroll">
        <h5 style={{textAlign: 'center'}}>Period Based Report</h5>
        <div style={{textAlign: 'center'}}>{dateInputs}</div>
        <div style={{textAlign: 'center'}}>{checkboxInputs}</div>
        <br/>
        <div/>
        <h6 style={{textAlign: 'center', fontSize:'15'}}><b>Claims Entered</b></h6>
        {ClaimsEnteredTable}
        {OpenDiagnosisTable}
        <div/>
        <h6 style={{textAlign: 'center', fontSize:'15'}}><b>Claims Closed</b></h6>
        {ClaimsClosedTable}
        {ClosedDiagnosisTable}
        {ClaimsClosedBySettlementTable}
        {ClaimsChangeStatusTable}
      </div>
    )
  }
}
